<template>
  <special-requests-grid
    :value="value"
    :is-edit="!disabled"
    :customer-id="innerCustomerId"
    :lob="job.lob"
    :job="job"
    @input="onInput"
  />
</template>

<script>
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'

export default {
  name: 'AeBasicSpecialRequestsGrid',
  components: {
    specialRequestsGrid
  },
  props: {
    value: { type: String, default: () => '' },
    job: { type: Object, default: () => {} },
    customerId: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      innerCustomerId: 0
    }
  },
  watch: {
    customerId(newVal) {
      this.innerCustomerId = newVal
    }
  },
  mounted() {
    this.innerCustomerId = this.customerId
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
